<template>
<div class="page page_adress">
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
		<div class="list">
			<div class="item" v-for="item in dataList" :key="item.id">
				<div class="item_top border">
					<div class="user">
						<div class="name"><span class="">姓名：</span>{{ item.name }}</div>
						<!-- <div class="name"><span class="">电话：</span>{{ item.phone }}</div> -->
						<div class="name"><span class="">证件号：</span>{{ item.card_no }}</div>
					</div>
					<van-radio-group v-model="item.type_id" direction="horizontal" >
						<van-radio :name="type.type_id" v-for="type in item.ticket_type" :key="type.id" @click="typeClick(item,type)">
							{{ type.type_name }}
							<template #icon="props">
								<img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
							</template>
						</van-radio>
					</van-radio-group>
				</div>
				<div class="item_bottom">
					<div :class="item.is_select ? 'default' :'default_un'" @click="bindSelectVisitor(item)"></div>
					<div class="actions clearfix">
						<div class="action f-l" @click="toEdit(item)">编辑</div>
						<div class="action f-l" @click="bindDelet(item)">删除</div>
					</div>
				</div>
			</div>
		</div>
	</van-list>	
    <!-- 新建收货地址 -->
    <div class="visitor_bottom">
        <div class="action_visitor" @click="addVisitor">+添加参观者</div>
		<div class="action_visitor" @click="updateVisitorList">确定</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			pages: {
				page: 1,
				size: 10
			},
			dataList: [], // 参观者列表
			loading: true,
			finished: false,
			visitorList: null, // 已选的参观者
			currentVisitor: null,
			ticket_type: null, // 票类型
			ticket_price: null, // 票价
			userTicket: null, // 用户已选的票务信息
			activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '智慧园区',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						// 已选的参观者
						this.visitorList = localStorage.getItem('visitorList') ? JSON.parse(localStorage.getItem('visitorList')) : []
						// 已选的票
						this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
						if(this.userTicket){
							// 获取票所在 园区或园区下场馆的票类型
							this.getTicketType()
						}
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			// 已选的参观者
			this.visitorList = localStorage.getItem('visitorList') ? JSON.parse(localStorage.getItem('visitorList')) : []
			// 已选的票
			this.userTicket = JSON.parse(localStorage.getItem('userTicket'))
			if(this.userTicket){
				// 获取票所在 园区或园区下场馆的票类型
				this.getTicketType()
			}
        }
		
    },
	mounted() {
	},
    methods: {
		// 获取参观者列表
		getData(){
			var that = this
			var params = {
				token: that.token,
				page: that.pages.page,
				size: that.pages.size
			}
			that.$api.smartpark.visitorlist(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					// 有数据
					console.log('selectVistorList:',localStorage.getItem('tempVisitorList'))
					var selectVistorList = localStorage.getItem('tempVisitorList') ? JSON.parse(localStorage.getItem('tempVisitorList')) : []
					console.log('selectVistorList:',selectVistorList)
					if(list.length != 0){
						for(var i in list) {
							var item = list[i]
							item.ticket_type = that.ticket_type
							if (that.ticket_type.length > 0) {
								var ticket = that.ticket_type[0]
								item.type_id = ticket.type_id
							}
							
							for (let j = 0; j < selectVistorList.length; j++) {
								const vistor = selectVistorList[j];
								if (vistor.id == item.id) {
									item.is_select = true
									item.type_id = vistor.type_id
									item.type_title = vistor.type_title
									item.type_price = vistor.type_price
								}
								
							}
							// list[i].ticket_price = that.ticket_price
							// list[i].type_id = that.ticket_type[0].id
							that.dataList.push(item)
						}
						// 分页加载
						that.pages.page++
						that.loading = false
						localStorage.removeItem('tempVisitorList')
					}else if(list.length == 0){
						// 数据加载完毕
						that.finished = true
					}
				}else{
					that.finished = true
				}
			})
		},
		// 添加参观者
		addVisitor(){
			var that = this
			that.$router.push('/smart/park/addvisitor')
		},
		// 选择参观者
		bindSelectVisitor(item){
			var that = this
			if(!item.type_id){
				that.$toast('请先勾选票类型')
				return
			}
			var list = that.dataList
			for(var i in list){
				if(list[i].id == item.id){
					list[i].is_select = !list[i].is_select
					// console.log('当前的参观者',list[i])
					// 票类型id title price
					for(var j in list[i].ticket_type){
						if(list[i].type_id == list[i].ticket_type[j].type_id){
							list[i].type_title = list[i].ticket_type[j].type_name
							list[i].type_price = list[i].ticket_type[j].price
						}
					}
					break
					// console.log('票类型id=====',list[i].type_id)
					// 更新参观者
				}
			}
			that.dataList = []
			that.dataList = list
			// console.log('列表===',that.dataList)
		},
		typeClick(item,type) {
			console.log(item)
			console.log(type)
			item.type_title = type.type_name
		},
		// 更新参观者
		updateVisitorList(item){
			// console.log('更新参观者item====',item)
			var that = this
			that.visitorList = []
			var list = that.dataList
			for(var i in list){
				var visitor = list[i]
				if (visitor.is_select) {
					that.visitorList.push(visitor)
				}
			}
			console.log(that.visitorList)
			localStorage.setItem('visitorList',JSON.stringify(that.visitorList))
			that.$router.back()
			// console.log('参观者信息',that.visitorList)
		},
		// 票类型
		getTicketType(){
			var that = this
			var params = {
				token: that.token,
				// venue_id: that.userTicket.venue_id,
				// smarkpark_id: that.userTicket.smarkpark_id,
				// is_through_ticket: that.userTicket.is_through_ticket,
				ticket_id: that.userTicket.id,
				// type_id: 1
			}
			// that.$api.smartpark.setinfo(params).then(res=>{
			// 	if(res.code == 200){
			// 		that.ticket_type = res.result.ticket_type
			// 		that.ticket_price = res.result.ticket_price
			// 		// 参观者列表
			// 		that.getData()
			// 	}
			// })
			that.$api.smartpark.tickettype(params).then(res=>{
				if(res.code == 200){
					that.ticket_type = res.result
					// 参观者列表
					that.getData()
				}
			})
		},
		// 去编辑参观者
		toEdit(item){
			var that = this
			that.$router.push({
				path: '/smart/park/addvisitor',
				query: {
					id: item.id
				}
			})
		},
		// 删除参观者
		bindDelet(item){
			var that = this
			// 缓存中的已添加参观者
			var list = JSON.parse(localStorage.getItem('visitorList'))
			var params = {
				token: that.token,
				id: item.id
			}
			that.$api.smartpark.visitordel(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message)
					// 更新列表
					that.pages.page = 1
					that.dataList = []
					that.getData()
					// 更新已添加参观者
					if(list && list.length != 0){
						for(var i = 0; i < list.length;i++){
							if(list[i].id == item.id){
								list.splice(i,1)
								console.log('参观者',list)
								localStorage.setItem('visitorList',JSON.stringify(list))
								break;
							}
						}
					}
				}
			})
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

.visitor_bottom {
	position: fixed;
	bottom: 0rem;
	padding: 0.53rem;
	background: #fff;
	display: flex;
	justify-content: space-around;
    justify-self: center;
    align-items: center;
}

.action_visitor {
	margin-left: 0.3rem;
	width: 4rem;
	height: 1rem;
	background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
	border-radius: 1rem;
	line-height: 1rem;
	text-align: center;
	font-size: 0.43rem;
	color: rgba(255, 255, 255, 1);
}

</style>
